export default __webpack_public_path__ + "static/media/081.73101256.jpg";